{
  "titles": {
    "payments": "Betalingen",
    "groups": "Groepen",
    "menu": "Bemiddelingsfee",
    "feeOverview": "Bemiddelingsfee overzicht",
    "invoice": "Factuur",
    "invoiceSpecification": "Factuurspecificatie"
  },
  "fields": {
    "labels": {
      "totalActiveFundingContractAmount": "Actieve inleg",
      "totalActiveFundingContracts": "Actieve contracten"
    }
  },
  "columns": {
    "amountRange": "Vanaf",
    "year": "Jaar",
    "fromYear": "Vanaf jaar",
    "from": "Van",
    "till": "Tot"
  },
  "messages": {
    "noPayments": "Er is nog geen uitbetaling gedaan",
    "infoOverPartnerFee": "Elk jaar wordt op 1 januari bepaald in welke groep je terecht komt."
  },
  "FeeGroup": {
    "Bronze": "Brons",
    "Silver": "Zilver",
    "Gold": "Goud"
  }
}
